<script>
	import Router from 'svelte-spa-router';
	import Header from './organisms/Header.svelte';
	import Accueil from './routes/Accueil.svelte';
	import Contact from './routes/Contact.svelte';
	import FullSubPortfolio from './routes/FullSubPortfolio.svelte';
	import Portefolio from './routes/Portefolio.svelte';
	import Presentation from './routes/Presentation.svelte';

	import { loadData } from './service';
	import Footer from './organisms/Footer.svelte';

	const routes = {
		'/': Accueil,
		'/presentation': Presentation,
		'/portefolio': Portefolio,
		'/portefolio/:id': FullSubPortfolio,
		'/contact': Contact,
	};

	loadData();
</script>

<Header />
<main>
	<Router {routes} restoreScrollState={true} />
</main>

<Footer />

<style>
	main {
		margin-top: 41px;
		text-align: center;
	}

	:global(body) {
		padding: 0px;
	}

	:global(img) {
		box-shadow: 10px 5px 5px rgba(157, 138, 186);
	}

	:global(input) {
		margin: 5px 0px;
	}
</style>
